import * as UserActions from '../actions/user'
import { User } from '../models'

export interface State {
  currentUser: User
}

const initialState: State = {
  currentUser: null,
}

export function reducer(state: State = initialState, action: UserActions.All): State {
  switch (action.type) {
    case UserActions.SET_CURRENT_USER: {
      return { currentUser: action.user }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.ts